// extracted by mini-css-extract-plugin
export default {"cardWrapper":"ContentItem_cardWrapper__-gWWL"};